import isChromatic from "chromatic/isChromatic";
import { DateTime } from "luxon";

export const appEnv = (process.env.APP_ENVIRONMENT ?? "development") as
  | "development"
  | "production"
  | "preview"
  | "staging";

export const buildId = process.env.BUILD_ID;
export const isDevelopment = appEnv === "development";
export const isProduction = appEnv === "production";
export const isPreview = appEnv === "preview";
export const isStaging = appEnv === "staging";
export const isTestBuild = process.env.NEXT_PUBLIC_BUILD_TYPE === "test";

export const bootTime = DateTime.now();

export const isSSR = () => typeof window === "undefined";

export const isStorybook = process.env.STORYBOOK !== undefined || isChromatic();
export const isJest = () => process.env.JEST_WORKER_ID !== undefined;

export const isEndToEndTest = () =>
  !isSSR() &&
  !isJest() &&
  ((!isWebWorker() && Boolean(window.Playwright)) || isTestBuild);

export const isUserBrowser = () =>
  !isSSR() && !isStorybook && !isEndToEndTest() && !isJest();

export const platform = (): "Mac" | "Windows" | "Other" => {
  if (isSSR()) {
    return "Other";
  }

  // N.B. not currently using one of the many libraries out there because
  // they're huge and overkill for what we need, and ideally we have a minimal
  // platform switching.
  // See https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform#examples.
  const userPlatform = window.navigator.platform;
  if (userPlatform.includes("Mac")) {
    return "Mac";
  }

  if (userPlatform.includes("Win")) {
    return "Windows";
  }

  return "Other";
};

export function isWebWorker() {
  return typeof Worker !== "undefined" && self instanceof Worker;
}

export const isMac = !isWebWorker() && platform() === "Mac";

export const backendUrl = process.env.BACKEND_URL as string;
